import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Activity, Bug, ChevronDown, KeyRound, Palette, ShieldCheck, Video, Workflow, Youtube } from "lucide-react";
import "./adminDashboardMenu.css";
import { useAuth } from "../contexts/AuthContext";
import { useWatermark } from "../contexts/WatermarkContext";
import { useSteamVideoSafety } from "../contexts/SteamVideoSafetyContext";

const ADMIN_DASHBOARDS = [
  { to: "/steam_debug", label: "Steam Debug", Icon: Bug },
  { to: "/admin/xbox", label: "Xbox Operations", Icon: Activity },
  { to: "/admin/tiktok", label: "TikTok Admin", Icon: Video },
  { to: "/admin/youtube", label: "YouTube Admin", Icon: Youtube },
  { to: "/page-access", label: "Page Access", Icon: KeyRound },
  { to: "/admin/brand", label: "Brand Library", Icon: Palette },
  { to: "/admin/architecture/mindshare", label: "Inside mindSHARE", Icon: Workflow },
  { to: "/admin/architecture/tiktok", label: "Inside TikTok", Icon: Workflow },
];

export default function AdminDashboardMenu() {
  const { currentUser } = useAuth();
  const { hidden, toggle } = useWatermark();
  const { showNsfwVideos, toggleNsfwVideos } = useSteamVideoSafety();
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const closeOutside = (event) => {
      if (!menuRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", closeOutside);
    return () => document.removeEventListener("pointerdown", closeOutside);
  }, [open]);

  if (!currentUser?.is_admin) return null;

  return (
    <div
      className="mg-admin-dashboard-menu"
      ref={menuRef}
      onKeyDown={(event) => {
        event.stopPropagation();
        if (event.key === "Escape") {
          setOpen(false);
          buttonRef.current?.focus();
        }
      }}
    >
      <button
        type="button"
        className="mg-admin-dashboard-toggle"
        ref={buttonRef}
        aria-expanded={open}
        aria-controls="mg-admin-dashboard-links"
        onClick={() => setOpen((value) => !value)}
      >
        <ShieldCheck size={16} aria-hidden="true" />
        <span>Admin</span>
        <ChevronDown size={14} aria-hidden="true" className={open ? "is-open" : ""} />
      </button>
      {open && (
        <nav id="mg-admin-dashboard-links" className="mg-admin-dashboard-links" aria-label="Admin dashboards">
          {ADMIN_DASHBOARDS.map(({ to, label, Icon }) => (
            <Link key={to} to={to} onClick={() => setOpen(false)}>
              <Icon size={16} aria-hidden="true" />
              <span>{label}</span>
            </Link>
          ))}
          {currentUser?.is_admin && (
            <label className="mg-admin-watermark-toggle">
              <span>Show beta watermark</span>
              <input type="checkbox" role="switch" checked={!hidden} onChange={toggle} />
            </label>
          )}
          <label className="mg-admin-watermark-toggle">
            <span>Show NSFW videos</span>
            <input
              type="checkbox"
              role="switch"
              checked={showNsfwVideos}
              onChange={toggleNsfwVideos}
            />
          </label>
        </nav>
      )}
    </div>
  );
}